// HomeScreen.jsx - Full-screen iPhone-stijl App Launcher (PERFORMANCE OPTIMIZED)
import { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import {
  Bot,
  CheckSquare,
  Users,
  ClipboardList,
  Utensils,
  ShoppingCart,
  Brush,
  PartyPopper,
  Calendar,
  Users2,
  FileText,
  Star,
  Trash2,
  ChevronRight,
  MapPin,
  Pill,
  Home,
  Settings,
  LogOut,
  Sparkles,
  Sun,
  Moon,
  X,
  Heart,
  CalendarDays,
  Dumbbell,
  Coffee,
  PenLine,
  ChevronLeft,
  Briefcase,
  FolderOpen,
  Clock,
  Wifi,
  Award,
  GraduationCap,
  BookOpen,
  ExternalLink,
  Car,
} from 'lucide-react';

// NIEUWE STRUCTUUR: 6 Hoofdcategorieën met subcategorieën
// Aangepast aan terminologie begeleid wonen / beschermde woonvoorziening
const MAIN_CATEGORIES = [
  {
    id: 'dagelijks-werk',
    name: 'Rapportage & Overdracht',
    subtitle: 'Dagrapportage & taken',
    icon: CheckSquare,
    gradient: 'from-emerald-500 to-emerald-600',
    shadowColor: 'shadow-emerald-400/20',
    apps: [
      { id: 'checklist', name: 'Checklist', subtitle: 'Dienst taken', icon: CheckSquare, target: 'checklist' },
      { id: 'rapportage-tool', name: 'Rapportage tool', subtitle: 'AI Rapportages', icon: PenLine, target: 'rapporteer-helper' },
      { id: 'pb-overzicht-shortcut', name: 'Voor PB\'ers', subtitle: 'Deadlines & events', icon: Users, target: 'pb-overzicht' },
      { id: 'rapportage-controle', name: 'Rapportage Controle', subtitle: 'Controleer sjablonen', icon: ClipboardList, target: 'rapportage-controle', adminOnly: true },
      { id: 'overdracht', name: 'Overdracht', subtitle: 'Dienstoverdracht', icon: ClipboardList, target: 'overdracht' },
      { id: 'corvee', name: 'Corvee', subtitle: 'Taken verdeling', icon: Brush, target: 'corvee' },
      { id: 'klusjes', name: 'Klusjes', subtitle: 'Reparaties', icon: Settings, target: 'klusjes' },
    ]
  },
  {
    id: 'clienten-zorg',
    name: 'Cliëntbegeleiding',
    subtitle: 'Zorg & ondersteuning',
    icon: Users,
    gradient: 'from-violet-500 to-purple-600',
    shadowColor: 'shadow-violet-400/20',
    apps: [
      { id: 'clienten', name: 'Cliënten', subtitle: 'Bewonersoverzicht', icon: Users, target: 'clienten' },
      { id: 'medicatie', name: 'Medicatie', subtitle: 'Medicatiebeheer', icon: Pill, target: 'medicatie' },
      { id: 'pb-gesprekken', name: 'PB Gesprekken', subtitle: 'Begeleidingsgesprekken', icon: ClipboardList, target: 'pb-gesprekken' },
      { id: 'revalidatie', name: 'Revalidatie', subtitle: 'Hersteltraject', icon: Heart, target: 'revalidatie', onlyForLocations: ['groep-zwaluw'] },
      { id: 'evaluatie-overzicht', name: 'Evaluaties', subtitle: 'Zorgplan & RI+E', icon: ClipboardList, target: 'evaluatie-overzicht' },
      { id: 'afspraken', name: 'Afspraken', subtitle: 'Cliëntafspraken', icon: Calendar, target: 'afspraken' },
      { id: 'dagbesteding', name: 'Dagbesteding', subtitle: 'Activiteiten', icon: Dumbbell, target: 'dagbesteding' },
    ]
  },
  {
    id: 'huishouden',
    name: 'Wonen & Huishouden',
    subtitle: 'Maaltijden & huisregels',
    icon: Home,
    gradient: 'from-orange-500 to-amber-500',
    shadowColor: 'shadow-orange-400/20',
    apps: [
      { id: 'weekmenu', name: 'Weekmenu', subtitle: 'Maaltijdplanning', icon: Utensils, target: 'weekmenu' },
      { id: 'boodschappen', name: 'Boodschappen', subtitle: 'Boodschappenlijst', icon: ShoppingCart, target: 'boodschappen' },
      { id: 'eetmomenten', name: 'Eetmomenten', subtitle: 'Maaltijdregistratie', icon: Coffee, target: 'eetmomenten' },
      { id: 'huisafspraken', name: 'Huisregels', subtitle: 'Afspraken woongroep', icon: Home, target: 'huisafspraken' },
      { id: 'afvalkalender', name: 'Afvalkalender', subtitle: 'Ophaaldata', icon: Trash2, target: 'afvalkalender' },
    ]
  },
  {
    id: 'planning-rooster',
    name: 'Team & Planning',
    subtitle: 'Rooster & overleg',
    icon: CalendarDays,
    gradient: 'from-blue-500 to-indigo-600',
    shadowColor: 'shadow-blue-400/20',
    apps: [
      { id: 'rooster', name: 'Werkrooster', subtitle: 'Dienstplanning', icon: CalendarDays, target: 'rooster' },
      { id: 'vergaderingen', name: 'Bewonersoverleg', subtitle: 'Huisvergadering', icon: Calendar, target: 'vergaderingen' },
      { id: 'mdo', name: 'MDO', subtitle: 'Multidisciplinair', icon: FileText, target: 'mdo' },
      { id: 'teamuitjes', name: 'Teamuitjes', subtitle: 'Groepsactiviteiten', icon: PartyPopper, target: 'teamuitjes' },
      { id: 'teamoverleg', name: 'Teamoverleg', subtitle: 'Begeleiders', icon: Users2, target: 'teamoverleg' },
    ]
  },
  {
    id: 'beloningen',
    name: 'Beloningssysteem',
    subtitle: 'Fiches & tokens',
    icon: Star,
    gradient: 'from-amber-500 to-yellow-500',
    shadowColor: 'shadow-amber-400/20',
    apps: [
      { id: 'fiches', name: 'Fiches', subtitle: 'Beloningen toekennen', icon: Star, target: 'fiches' },
    ]
  },
  {
    id: 'hkz-management',
    name: 'HKZ Management',
    subtitle: 'Kwaliteitsdocumentatie',
    icon: Award,
    gradient: 'from-violet-600 to-purple-700',
    shadowColor: 'shadow-violet-500/30',
    highlight: true,
    apps: [
      { id: 'hkz', name: 'HKZ Dashboard', subtitle: 'Kwaliteitsmanagement', icon: Award, target: 'hkz' },
    ]
  },
  {
    id: 'overig',
    name: 'Hulpmiddelen',
    subtitle: 'AI & instellingen',
    icon: Settings,
    gradient: 'from-slate-500 to-slate-600',
    shadowColor: 'shadow-slate-400/20',
    apps: [
      { id: 'ai-chat', name: 'AI Assistent', subtitle: 'Vraag Sahbi', icon: Bot, action: 'openAiChat' },
      { id: 'wifi', name: 'WiFi', subtitle: 'Netwerkinformatie', icon: Wifi, target: 'wifi' },
      { id: 'parkeer-hulp', name: 'Hoe parkeer ik?', subtitle: 'Stappenplan kenteken', icon: Car, target: 'parkeer-hulp', onlyForLocations: ['groep-adelaars'] },
    ]
  },
  {
    id: 'voor-pbers',
    name: 'Voor PB\'ers',
    subtitle: 'Zorgplannen & deadlines',
    icon: Heart,
    gradient: 'from-rose-500 to-pink-600',
    shadowColor: 'shadow-rose-400/20',
    apps: [
      { id: 'pb-overzicht', name: 'PB Overzicht', subtitle: 'Zorgplannen & evaluaties', icon: ClipboardList, target: 'pb-overzicht' },
    ]
  },
];

// Oude APPS array voor backwards compatibility (wordt niet meer direct gebruikt)
const APPS = [];

// Apps alleen voor gedragswetenschapper
const GEDRAGSWETENSCHAPPER_APPS = [
  {
    id: 'zorgplan-evaluaties',
    name: 'Zorgplan Evaluaties',
    subtitle: 'Gedragswetenschapper',
    icon: FileText,
    gradient: 'from-violet-400 to-purple-500',
    shadowColor: 'shadow-violet-500/30',
    action: 'navigateTo',
    target: 'zorgplan-evaluaties',
  },
  {
    id: 'rie-evaluaties',
    name: 'RI+E Evaluaties',
    subtitle: 'Gedragswetenschapper',
    icon: ClipboardList,
    gradient: 'from-red-400 to-rose-500',
    shadowColor: 'shadow-red-500/30',
    action: 'navigateTo',
    target: 'rie-evaluaties',
  },
];

// AppIcon Component - Large, tappable icons (OPTIMIZED - reduced animations)
const AppIcon = ({ app, badge, onClick, index }) => {
  return (
    <button
      onClick={onClick}
      className="flex flex-col items-center gap-2 p-1 group focus:outline-none active:scale-95 transition-transform duration-150"
      data-testid={`app-icon-${app.id}`}
    >
      {/* Icon Container */}
      <div className="relative">
        {/* Main Icon */}
        <div className={`relative w-[72px] h-[72px] sm:w-20 sm:h-20 rounded-[22px] bg-gradient-to-br ${app.gradient} shadow-lg ${app.shadowColor} flex items-center justify-center overflow-hidden`}>
          <app.icon className="w-8 h-8 sm:w-9 sm:h-9 text-white drop-shadow-md relative z-10" strokeWidth={1.8} />
        </div>
        
        {/* Badge */}
        {badge > 0 && (
          <div className="absolute -top-1.5 -right-1.5 min-w-[22px] h-[22px] px-1.5 bg-red-500 rounded-full flex items-center justify-center shadow-lg border-2 border-white">
            <span className="text-[11px] font-bold text-white">{badge > 99 ? '99+' : badge}</span>
          </div>
        )}
        
        {/* Special Badge (like 24/7) */}
        {app.badge && (
          <div className={`absolute -top-1 -right-1 px-1.5 py-0.5 ${app.badgeColor || 'bg-amber-500'} rounded-full shadow-lg border-2 border-white`}>
            <span className="text-[9px] font-bold text-white">{app.badge}</span>
          </div>
        )}
      </div>
      
      {/* Label */}
      <div className="text-center w-20">
        <p className="text-[13px] font-semibold text-slate-800 leading-tight truncate">{app.name}</p>
      </div>
    </button>
  );
};

// Afvalkalender Alert Component (OPTIMIZED)
const AfvalAlert = ({ onNavigate }) => {
  const [dismissed, setDismissed] = useState(false);
  
  // Afvalkalender data 2025-2026
  const afvalData = [
    '2025-01-09', '2025-01-23', '2025-02-06', '2025-02-20', '2025-03-06', '2025-03-20',
    '2025-04-03', '2025-04-17', '2025-05-01', '2025-05-15', '2025-05-29', '2025-06-12',
    '2025-06-26', '2025-07-10', '2025-07-24', '2025-08-07', '2025-08-21', '2025-09-04',
    '2025-09-18', '2025-10-02', '2025-10-16', '2025-10-30', '2025-11-13', '2025-11-27',
    '2025-12-11', '2025-12-25',
    '2026-01-08', '2026-01-22', '2026-02-05', '2026-02-19', '2026-03-05', '2026-03-19',
    '2026-04-02', '2026-04-16', '2026-04-30', '2026-05-14', '2026-05-28', '2026-06-11',
    '2026-06-25', '2026-07-09', '2026-07-23', '2026-08-06', '2026-08-20', '2026-09-03',
    '2026-09-17', '2026-10-01', '2026-10-15', '2026-10-29', '2026-11-12', '2026-11-26',
    '2026-12-10', '2026-12-24',
  ];
  
  const today = new Date();
  const todayStr = today.toISOString().split('T')[0];
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);
  const tomorrowStr = tomorrow.toISOString().split('T')[0];
  
  const isTomorrowPickupDay = afvalData.includes(tomorrowStr);
  const isTodayPickupDay = afvalData.includes(todayStr);
  
  // Alleen tonen als morgen ophaaldag is OF vandaag ophaaldag is
  if (dismissed || (!isTomorrowPickupDay && !isTodayPickupDay)) return null;
  
  return (
    <div
      className={`mb-4 p-4 rounded-2xl ${isTodayPickupDay ? 'bg-gradient-to-r from-red-500 to-rose-500' : 'bg-gradient-to-r from-amber-500 to-orange-500'} text-white shadow-lg`}
      data-testid="afval-alert"
    >
      <div className="flex items-start justify-between">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-xl bg-white/20 flex items-center justify-center flex-shrink-0">
            <Trash2 className="w-5 h-5 text-white" />
          </div>
          <div>
            <h3 className="font-semibold">
              {isTodayPickupDay ? '🚨 Vandaag is ophaaldag!' : '📅 Morgen is ophaaldag!'}
            </h3>
            <p className="text-sm text-white/90 mt-1">
              {isTodayPickupDay 
                ? 'Zorg dat de restafval container aan de straat staat!'
                : 'Vergeet niet de restafval container vanavond aan de straat te zetten.'}
            </p>
          </div>
        </div>
        <button 
          onClick={() => setDismissed(true)}
          className="p-1 rounded-lg hover:bg-white/20 transition-colors"
        >
          <X className="w-4 h-4 text-white" />
        </button>
      </div>
      <button 
        onClick={() => onNavigate('afvalkalender')}
        className="mt-3 w-full py-2 rounded-xl bg-white/20 hover:bg-white/30 text-sm font-medium transition-colors"
      >
        Bekijk afvalkalender
      </button>
    </div>
  );
};

// Afspraken Reminder Alert Component
const AfsprakenAlert = ({ onNavigate }) => {
  const [dismissed, setDismissed] = useState(false);
  const [afspraken, setAfspraken] = useState({ vandaag: [], morgen: [] });
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    const fetchReminders = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          setLoading(false);
          return;
        }
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/afspraken/reminders`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }
        const data = await response.json();
        setAfspraken({ 
          vandaag: Array.isArray(data?.vandaag) ? data.vandaag : [], 
          morgen: Array.isArray(data?.morgen) ? data.morgen : [] 
        });
      } catch (error) {
        console.error('Error fetching afspraken reminders:', error);
        // Stille fout - toon gewoon geen reminders als het mislukt
        setAfspraken({ vandaag: [], morgen: [] });
      } finally {
        setLoading(false);
      }
    };
    fetchReminders();
  }, []);
  
  if (loading || dismissed || (afspraken.vandaag.length === 0 && afspraken.morgen.length === 0)) return null;
  
  const totalAfspraken = afspraken.vandaag.length + afspraken.morgen.length;
  const hasToday = afspraken.vandaag.length > 0;
  
  return (
    <div
      className={`mb-4 p-4 rounded-2xl ${hasToday ? 'bg-gradient-to-r from-purple-600 to-pink-600' : 'bg-gradient-to-r from-indigo-500 to-purple-600'} text-white shadow-lg`}
      data-testid="afspraken-alert"
    >
      <div className="flex items-start justify-between">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-xl bg-white/20 flex items-center justify-center flex-shrink-0">
            <Calendar className="w-5 h-5 text-white" />
          </div>
          <div className="flex-1">
            <h3 className="font-semibold flex items-center gap-2">
              {hasToday ? '📅 Afspraken vandaag!' : '📆 Afspraken morgen'}
              <span className="px-2 py-0.5 bg-white/30 rounded-full text-xs">{totalAfspraken}</span>
            </h3>
            <div className="mt-2 space-y-1.5">
              {afspraken.vandaag.slice(0, 2).map((a) => (
                <div key={a.id || `${a.client_naam}-${a.tijd}-${a.type_afspraak}`} className="text-sm text-white/90 flex items-center gap-2">
                  <span className="px-1.5 py-0.5 bg-white/20 rounded text-xs font-semibold">{a.tijd}</span>
                  <span className="font-medium">{a.client_naam}</span>
                  <span className="text-white/70">• {a.type_afspraak}</span>
                  {a.zelfstandig ? (
                    <span className="text-xs bg-green-400/30 px-1.5 py-0.5 rounded">zelfstandig</span>
                  ) : a.begeleider_meegaat && (
                    <span className="text-xs bg-blue-400/30 px-1.5 py-0.5 rounded">{a.begeleider_meegaat} gaat mee</span>
                  )}
                </div>
              ))}
              {afspraken.vandaag.length === 0 && afspraken.morgen.slice(0, 2).map((a) => (
                <div key={a.id || `morgen-${a.client_naam}-${a.tijd}-${a.type_afspraak}`} className="text-sm text-white/90 flex items-center gap-2">
                  <span className="px-1.5 py-0.5 bg-white/20 rounded text-xs font-semibold">{a.tijd}</span>
                  <span className="font-medium">{a.client_naam}</span>
                  <span className="text-white/70">• {a.type_afspraak}</span>
                  {a.zelfstandig ? (
                    <span className="text-xs bg-green-400/30 px-1.5 py-0.5 rounded">zelfstandig</span>
                  ) : a.begeleider_meegaat && (
                    <span className="text-xs bg-blue-400/30 px-1.5 py-0.5 rounded">{a.begeleider_meegaat} gaat mee</span>
                  )}
                </div>
              ))}
              {totalAfspraken > 2 && (
                <p className="text-xs text-white/70">+ {totalAfspraken - 2} meer afspraken</p>
              )}
            </div>
          </div>
        </div>
        <button 
          onClick={() => setDismissed(true)}
          className="p-1 rounded-lg hover:bg-white/20 transition-colors"
        >
          <X className="w-4 h-4 text-white" />
        </button>
      </div>
      <button 
        onClick={() => onNavigate('afspraken')}
        className="mt-3 w-full py-2 rounded-xl bg-white/20 hover:bg-white/30 text-sm font-medium transition-colors"
      >
        Bekijk alle afspraken
      </button>
    </div>
  );
};

// Quick Action Card (Performance optimized)
const QuickActionCard = ({ icon: Icon, title, subtitle, gradient, onClick }) => (
  <button
    onClick={onClick}
    className="flex-1 min-w-[140px] p-4 rounded-2xl bg-white/80 backdrop-blur-sm border border-white/50 shadow-lg active:scale-95 transition-transform text-left"
  >
    <div className={`w-11 h-11 rounded-xl bg-gradient-to-br ${gradient} flex items-center justify-center mb-3 shadow-md`}>
      <Icon className="w-5 h-5 text-white" />
    </div>
    <p className="text-sm font-semibold text-slate-800">{title}</p>
    <p className="text-xs text-slate-500 mt-0.5">{subtitle}</p>
  </button>
);

// Notification Banner (Performance optimized)
const NotificationBanner = ({ notifications, onNavigate }) => {
  const items = [
    notifications.vergadering && {
      icon: Calendar,
      text: 'Vergadering vandaag',
      detail: notifications.vergaderingDetail,
      gradient: 'from-sky-500 to-blue-600',
      action: () => onNavigate('vergaderingen'),
    },
    notifications.afval && {
      icon: Trash2,
      text: 'Afval buiten zetten',
      detail: notifications.afvalDetail,
      gradient: 'from-green-500 to-emerald-600',
      action: () => onNavigate('taken'),
    },
    notifications.boodschappen > 0 && {
      icon: ShoppingCart,
      text: `${notifications.boodschappen} items`,
      detail: 'Boodschappenlijst',
      gradient: 'from-teal-500 to-cyan-600',
      action: () => onNavigate('boodschappen'),
    },
  ].filter(Boolean);

  if (items.length === 0) return null;

  return (
    <div className="mb-6">
      <div className="flex gap-3 overflow-x-auto pb-2 scrollbar-hide">
        {items.map((item) => (
          <button
            key={item.text}
            onClick={item.action}
            className="flex items-center gap-3 px-4 py-3 bg-white/90 backdrop-blur-sm rounded-2xl border border-white/50 shadow-md min-w-fit active:scale-95 transition-transform"
          >
            <div className={`w-10 h-10 rounded-xl bg-gradient-to-br ${item.gradient} flex items-center justify-center shadow-sm`}>
              <item.icon className="w-5 h-5 text-white" />
            </div>
            <div className="text-left">
              <p className="text-sm font-semibold text-slate-800">{item.text}</p>
              <p className="text-xs text-slate-500">{item.detail}</p>
            </div>
            <ChevronRight className="w-4 h-4 text-slate-400 ml-2" />
          </button>
        ))}
      </div>
    </div>
  );
};

// Main HomeScreen Component - Full Screen
export const HomeScreen = ({ 
  user, 
  selectedLocation,
  onLocationChange,
  notifications = {},
  onOpenAiChat,
  onNavigateTo,
  onLogout,
}) => {
  const [currentTime, setCurrentTime] = useState(new Date());
  const [greeting, setGreeting] = useState('');
  const [latestOverdracht, setLatestOverdracht] = useState(null);
  const [showOverdrachtAlert, setShowOverdrachtAlert] = useState(false);
  const [showLocationSelector, setShowLocationSelector] = useState(false);
  
  // Check if user is zorgmanager (can see both groups)
  const isZorgmanager = user?.role === 'zorgmanager' || user?.role === 'admin';

  // Fetch latest overdracht on mount
  useEffect(() => {
    const fetchLatestOverdracht = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) return;
        
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/overdrachten/latest`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        
        if (!response.ok) {
          // Stille fout - overdracht is optioneel
          return;
        }
        
        const data = await response.json();
        if (data?.overdracht) {
          setLatestOverdracht(data.overdracht);
          // Show alert if overdracht is recent (last 12 hours)
          const overdrahtTime = new Date(data.overdracht.geschreven_op);
          const hoursSince = (Date.now() - overdrahtTime.getTime()) / (1000 * 60 * 60);
          if (hoursSince < 12) {
            setShowOverdrachtAlert(true);
          }
        }
      } catch (error) {
        // Stille fout - overdracht alert is niet kritiek
        console.error('Error fetching overdracht:', error);
      }
    };
    fetchLatestOverdracht();
  }, []);

  // Update time every minute
  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 60000);
    return () => clearInterval(timer);
  }, []);

  // Set greeting based on time
  useEffect(() => {
    const hour = currentTime.getHours();
    if (hour >= 5 && hour < 12) setGreeting('Goedemorgen');
    else if (hour >= 12 && hour < 17) setGreeting('Goedemiddag');
    else if (hour >= 17 && hour < 22) setGreeting('Goedenavond');
    else setGreeting('Goedenacht');
  }, [currentTime]);

  const handleAppClick = (app) => {
    if (app.action === 'openAiChat') {
      onOpenAiChat?.();
    } else if (app.externalUrl) {
      window.open(app.externalUrl, '_blank', 'noopener,noreferrer');
    } else if (app.target) {
      onNavigateTo?.(app.target);
    }
  };

  // Handler voor subcategorie app clicks
  const handleSubAppClick = (app) => {
    if (app.action === 'openAiChat') {
      onOpenAiChat?.();
    } else if (app.externalUrl) {
      window.open(app.externalUrl, '_blank', 'noopener,noreferrer');
    } else if (app.target) {
      onNavigateTo?.(app.target);
    }
  };

  const getBadge = (appId) => notifications[appId] || 0;

  // Dynamische locatienaam (demo-ondersteuning)
  const getLocationDisplayName = () => {
    if (selectedLocation === 'groep-demo') return 'Demo Woongroep';
    if (selectedLocation === 'groep-zwaluw') return 'Groep Zwaluw';
    if (selectedLocation === 'ambulant') return 'Ambulant';
    return 'Groep Adelaars';
  };
  const locationDisplayName = getLocationDisplayName();
  const firstName = user?.name?.split(' ')[0] || 'Begeleider';

  const handleLocationChange = (newLocation) => {
    if (onLocationChange) {
      onLocationChange(newLocation);
    }
    setShowLocationSelector(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-100 via-blue-50 to-indigo-100 relative overflow-hidden">
      {/* Location Selector Modal for Zorgmanager */}
      <AnimatePresence>
        {showLocationSelector && isZorgmanager && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4"
            onClick={() => setShowLocationSelector(false)}
          >
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              className="bg-white rounded-3xl p-6 w-full max-w-sm shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            >
              <h3 className="text-lg font-bold text-slate-800 mb-4 text-center">Selecteer Groep</h3>
              <div className="space-y-3">
                <button
                  onClick={() => handleLocationChange('groep-zwaluw')}
                  className={`w-full p-4 rounded-2xl flex items-center gap-4 transition-all ${
                    selectedLocation === 'groep-zwaluw'
                      ? 'bg-gradient-to-r from-blue-500 to-indigo-500 text-white shadow-lg'
                      : 'bg-slate-100 hover:bg-slate-200 text-slate-700'
                  }`}
                >
                  <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${
                    selectedLocation === 'groep-zwaluw' ? 'bg-white/20' : 'bg-blue-100'
                  }`}>
                    <Home className={`w-6 h-6 ${selectedLocation === 'groep-zwaluw' ? 'text-white' : 'text-blue-600'}`} />
                  </div>
                  <div className="text-left">
                    <p className="font-semibold">Groep Zwaluw</p>
                    <p className={`text-sm ${selectedLocation === 'groep-zwaluw' ? 'text-white/80' : 'text-slate-500'}`}>
                      Enschotsestraat 98-100
                    </p>
                  </div>
                  {selectedLocation === 'groep-zwaluw' && (
                    <CheckSquare className="w-5 h-5 ml-auto" />
                  )}
                </button>
                
                <button
                  onClick={() => handleLocationChange('groep-adelaars')}
                  className={`w-full p-4 rounded-2xl flex items-center gap-4 transition-all ${
                    selectedLocation === 'groep-adelaars'
                      ? 'bg-gradient-to-r from-orange-500 to-red-500 text-white shadow-lg'
                      : 'bg-slate-100 hover:bg-slate-200 text-slate-700'
                  }`}
                >
                  <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${
                    selectedLocation === 'groep-adelaars' ? 'bg-white/20' : 'bg-orange-100'
                  }`}>
                    <Home className={`w-6 h-6 ${selectedLocation === 'groep-adelaars' ? 'text-white' : 'text-orange-600'}`} />
                  </div>
                  <div className="text-left">
                    <p className="font-semibold">Groep Adelaars</p>
                    <p className={`text-sm ${selectedLocation === 'groep-adelaars' ? 'text-white/80' : 'text-slate-500'}`}>
                      Ardennenlaan 68
                    </p>
                  </div>
                  {selectedLocation === 'groep-adelaars' && (
                    <CheckSquare className="w-5 h-5 ml-auto" />
                  )}
                </button>
                
                <button
                  onClick={() => handleLocationChange('ambulant')}
                  className={`w-full p-4 rounded-2xl flex items-center gap-4 transition-all ${
                    selectedLocation === 'ambulant'
                      ? 'bg-gradient-to-r from-violet-500 to-purple-500 text-white shadow-lg'
                      : 'bg-slate-100 hover:bg-slate-200 text-slate-700'
                  }`}
                >
                  <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${
                    selectedLocation === 'ambulant' ? 'bg-white/20' : 'bg-violet-100'
                  }`}>
                    <Users className={`w-6 h-6 ${selectedLocation === 'ambulant' ? 'text-white' : 'text-violet-600'}`} />
                  </div>
                  <div className="text-left">
                    <p className="font-semibold">Ambulant</p>
                    <p className={`text-sm ${selectedLocation === 'ambulant' ? 'text-white/80' : 'text-slate-500'}`}>
                      Ambulante begeleiding
                    </p>
                  </div>
                  {selectedLocation === 'ambulant' && (
                    <CheckSquare className="w-5 h-5 ml-auto" />
                  )}
                </button>
              </div>
              <button
                onClick={() => setShowLocationSelector(false)}
                className="w-full mt-4 p-3 text-slate-500 hover:text-slate-700 text-sm font-medium"
              >
                Annuleren
              </button>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Decorative Background Elements - Simplified for performance */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-purple-200/20 rounded-full" />
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-blue-200/20 rounded-full" />
      </div>

      {/* Content */}
      <div className="relative z-10 min-h-screen flex flex-col">
        {/* Status Bar */}
        <div className="safe-area-inset-top" />
        <header className="px-6 pt-4 pb-2">
          <div className="flex items-center justify-between">
            {isZorgmanager ? (
              <button 
                onClick={() => setShowLocationSelector(true)}
                className="flex items-center gap-2 px-3 py-2 -ml-3 rounded-xl hover:bg-white/50 active:bg-white/70 transition-colors"
              >
                <div className={`w-8 h-8 rounded-full flex items-center justify-center shadow-lg ${
                  selectedLocation === 'groep-zwaluw' 
                    ? 'bg-gradient-to-br from-blue-500 to-indigo-600' 
                    : 'bg-gradient-to-br from-orange-500 to-red-600'
                }`}>
                  <MapPin className="w-4 h-4 text-white" />
                </div>
                <div className="text-left">
                  <span className="text-sm font-semibold text-slate-700 block">{locationDisplayName}</span>
                  <span className="text-xs text-violet-600">Wissel groep ▼</span>
                </div>
              </button>
            ) : (
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-gradient-to-br from-violet-500 to-purple-600 flex items-center justify-center shadow-lg">
                  <MapPin className="w-4 h-4 text-white" />
                </div>
                <span className="text-sm font-semibold text-slate-700">{locationDisplayName}</span>
              </div>
            )}
            <div className="flex items-center gap-3">
              <div className="text-right">
                <p className="text-xs text-slate-500">
                  {currentTime.toLocaleDateString('nl-NL', { weekday: 'short', day: 'numeric', month: 'short' })}
                </p>
                <p className="text-sm font-bold text-slate-800">
                  {currentTime.toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit' })}
                </p>
              </div>
              {currentTime.getHours() >= 6 && currentTime.getHours() < 20 ? (
                <Sun className="w-5 h-5 text-amber-500" />
              ) : (
                <Moon className="w-5 h-5 text-indigo-500" />
              )}
              <button
                onClick={onLogout}
                className="p-2.5 rounded-xl bg-white/80 hover:bg-red-50 border border-slate-200/50 shadow-sm hover:border-red-200 transition-all group"
                data-testid="logout-btn"
                title="Uitloggen"
              >
                <LogOut className="w-5 h-5 text-slate-500 group-hover:text-red-500 transition-colors" />
              </button>
            </div>
          </div>
        </header>

        {/* Main Content - Scrollable */}
        <main className="flex-1 px-6 py-4 overflow-auto">
          {/* Overdracht Alert */}
          {showOverdrachtAlert && latestOverdracht && (
            <motion.div
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              className="mb-4 p-4 rounded-2xl bg-gradient-to-r from-indigo-500 to-purple-500 text-white shadow-lg"
            >
              <div className="flex items-start justify-between">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-xl bg-white/20 flex items-center justify-center flex-shrink-0">
                    <FileText className="w-5 h-5 text-white" />
                  </div>
                  <div>
                    <h3 className="font-semibold">Nieuwe Overdracht</h3>
                    <p className="text-sm text-white/80">
                      Van {latestOverdracht.geschreven_door} • {new Date(latestOverdracht.geschreven_op).toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit' })}
                    </p>
                    <p className="text-sm text-white/90 mt-1 line-clamp-2">{latestOverdracht.tekst}</p>
                  </div>
                </div>
                <button 
                  onClick={() => setShowOverdrachtAlert(false)}
                  className="p-1 rounded-lg hover:bg-white/20 transition-colors"
                >
                  <X className="w-4 h-4 text-white" />
                </button>
              </div>
              <button 
                onClick={() => { setShowOverdrachtAlert(false); onNavigateTo('overdracht'); }}
                className="mt-3 w-full py-2 rounded-xl bg-white/20 hover:bg-white/30 text-sm font-medium transition-colors"
              >
                Bekijk alle overdrachten
              </button>
            </motion.div>
          )}

          {/* Afvalkalender Alert - Morgen is ophaaldag */}
          <AfvalAlert onNavigate={onNavigateTo} />
          
          {/* Afspraken Alert - Vandaag of morgen afspraken */}
          <AfsprakenAlert onNavigate={onNavigateTo} />

          {/* Greeting Section */}
          <div className="mb-8">
            <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-1">
              {greeting},
            </h1>
            <h2 className="text-3xl sm:text-4xl font-bold bg-gradient-to-r from-violet-600 via-purple-600 to-fuchsia-600 bg-clip-text text-transparent">
              {firstName}
            </h2>
            <p className="text-slate-500 mt-2 text-sm">Wat wil je vandaag doen?</p>
          </div>

          {/* Notifications */}
          <NotificationBanner notifications={notifications} onNavigate={onNavigateTo} />

          {/* Quick Actions */}
          <div className="mb-8">
            <h3 className="text-xs font-bold text-slate-500 uppercase tracking-wider mb-3">Snel naar</h3>
            <div className="flex gap-3 overflow-x-auto pb-2 scrollbar-hide">
              <QuickActionCard
                icon={Bot}
                title="Vraag Sahbi"
                subtitle="AI Assistent"
                gradient="from-sky-500 to-sky-500"
                onClick={onOpenAiChat}
              />
              <QuickActionCard
                icon={PenLine}
                title="Rapportage tool"
                subtitle="AI Rapportages"
                gradient="from-violet-500 to-purple-500"
                onClick={() => onNavigateTo('rapporteer-helper')}
              />
              <QuickActionCard
                icon={Users}
                title="Voor PB'ers"
                subtitle="Deadlines & events"
                gradient="from-rose-500 to-rose-500"
                onClick={() => onNavigateTo('pb-overzicht')}
              />
              <QuickActionCard
                icon={Calendar}
                title="Afspraken"
                subtitle="Cliëntafspraken"
                gradient="from-teal-500 to-teal-600"
                onClick={() => onNavigateTo('afspraken')}
              />
              {(selectedLocation === 'groep-adelaars' || (user?.locations && user.locations.includes('groep-adelaars'))) ? (
                <QuickActionCard
                  icon={Car}
                  title="Hoe parkeer ik?"
                  subtitle="Stappenplan"
                  gradient="from-blue-500 to-blue-600"
                  onClick={() => onNavigateTo('parkeer-hulp')}
                />
              ) : (
                <QuickActionCard
                  icon={CheckSquare}
                  title="Checklist"
                  subtitle="Dienst taken"
                  gradient="from-emerald-500 to-emerald-500"
                  onClick={() => onNavigateTo('checklist')}
                />
              )}
              <QuickActionCard
                icon={Pill}
                title="Medicatie"
                subtitle="Overzicht"
                gradient="from-pink-400 to-pink-400"
                onClick={() => onNavigateTo('medicatie')}
              />
            </div>
          </div>

          {/* App Grid */}
          <div className="mb-8">
            <h3 className="text-xs font-bold text-slate-500 uppercase tracking-wider mb-4">Categorieën</h3>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
              {MAIN_CATEGORIES.map((category) => {
                // HKZ Management is alleen zichtbaar voor eigenaar en gedragswetenschapper
                if (category.id === 'hkz-management') {
                  const hasHkzAccess = user?.hkz_access === true || 
                    user?.role === 'eigenaar' || 
                    user?.role === 'gedragswetenschapper' ||
                    user?.role === 'admin' ||
                    user?.email === 'beheerder@zorg-vleugel.nl' ||
                    user?.email === 'george@zorg-vleugel.nl';
                  if (!hasHkzAccess) return null;
                }
                
                // Filter apps op locatie - ook voor gecombineerde accounts
                const filteredApps = category.apps.filter(app => {
                  if (app.onlyForLocations && app.onlyForLocations.length > 0) {
                    // Check of huidige locatie in de lijst staat
                    if (app.onlyForLocations.includes(selectedLocation)) return true;
                    // Check of gebruiker een gecombineerd account heeft met toegang tot een van de locaties
                    if (user?.locations && user.locations.length > 1) {
                      return app.onlyForLocations.some(loc => user.locations.includes(loc));
                    }
                    return false;
                  }
                  return true;
                });
                
                if (filteredApps.length === 0) return null;
                
                // Als er maar 1 app is, navigeer direct daarheen
                const handleCategoryClick = () => {
                  if (filteredApps.length === 1 && filteredApps[0].target) {
                    onNavigateTo(filteredApps[0].target);
                  } else {
                    onNavigateTo(`category-${category.id}`);
                  }
                };
                
                return (
                  <button
                    key={category.id}
                    onClick={handleCategoryClick}
                    className={`p-4 bg-white/80 backdrop-blur-sm rounded-2xl border border-white/50 shadow-lg hover:shadow-xl active:scale-[0.98] transition-all text-left ${category.highlight ? 'ring-2 ring-violet-500/50' : ''}`}
                    data-testid={`category-${category.id}`}
                  >
                    <div className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${category.gradient} ${category.shadowColor} shadow-lg flex items-center justify-center mb-3`}>
                      <category.icon className="w-7 h-7 text-white" strokeWidth={1.8} />
                    </div>
                    <h4 className="font-bold text-slate-800 text-sm mb-0.5">{category.name}</h4>
                    <p className="text-xs text-slate-500">{filteredApps.length} items</p>
                  </button>
                );
              })}
            </div>
          </div>

          {/* ZZP Inwerken - Direct toegankelijk voor nieuwe medewerkers */}
          <div className="mb-8">
            <h3 className="text-xs font-bold text-teal-600 uppercase tracking-wider mb-4">ZZP Inwerken</h3>
            <div className="grid grid-cols-1 gap-4">
              <button
                onClick={() => onNavigateTo('inwerkbot')}
                className="p-4 bg-white/80 backdrop-blur-sm rounded-2xl border border-white/50 shadow-lg hover:shadow-xl active:scale-[0.98] transition-all text-left"
                data-testid="zzp-inwerkbot-direct"
              >
                <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-teal-500 to-teal-600 shadow-lg shadow-teal-400/30 flex items-center justify-center mb-3">
                  <BookOpen className="w-7 h-7 text-white" strokeWidth={1.8} />
                </div>
                <h4 className="font-bold text-slate-800 text-sm mb-0.5">Inwerkdocument</h4>
                <p className="text-xs text-slate-500">Interactieve checklist voor nieuwe ZZP'ers</p>
              </button>
            </div>
          </div>

          {/* Gedragswetenschapper Apps - alleen zichtbaar voor gedragswetenschapper */}
          {(user?.role === 'gedragswetenschapper' || user?.email === 'erva@zorg-vleugel.nl') && (
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4 }}
              className="mb-8"
            >
              <h3 className="text-xs font-bold text-purple-600 uppercase tracking-wider mb-4">Gedragswetenschapper</h3>
              <div className="grid grid-cols-4 sm:grid-cols-4 md:grid-cols-6 gap-4 sm:gap-6 justify-items-center">
                {GEDRAGSWETENSCHAPPER_APPS.map((app, index) => (
                  <AppIcon
                    key={app.id}
                    app={app}
                    badge={0}
                    onClick={() => handleAppClick(app)}
                    index={index}
                  />
                ))}
              </div>
            </motion.div>
          )}
        </main>

        {/* Bottom Navigation Bar - Premium iPhone Style (OPTIMIZED) */}
        <nav className="px-4 pb-6 pt-2">
          <div className="relative">
            {/* Nav Bar */}
            <div className="relative bg-white/90 backdrop-blur-sm rounded-[2rem] shadow-2xl border border-white/60 p-1.5 ring-1 ring-black/5">
              <div className="flex items-center justify-around">
                <button
                  className="flex flex-col items-center gap-1 px-4 sm:px-6 py-3 rounded-2xl bg-gradient-to-br from-slate-800 via-slate-900 to-black text-white shadow-lg shadow-slate-900/30 active:scale-95 transition-transform duration-150"
                  data-testid="nav-home"
                >
                  <Home className="w-5 h-5" />
                  <span className="text-[10px] font-bold tracking-wide">Home</span>
                </button>
                
                <button
                  onClick={() => onNavigateTo('rooster')}
                  className="flex flex-col items-center gap-1 px-4 sm:px-6 py-3 rounded-2xl hover:bg-slate-100 text-slate-400 hover:text-slate-700 active:scale-95 transition-transform duration-150"
                  data-testid="nav-rooster"
                >
                  <Calendar className="w-5 h-5" />
                  <span className="text-[10px] font-semibold">Rooster</span>
                </button>
                
                {/* Central AI Button - Floating Style */}
                <button
                  onClick={onOpenAiChat}
                  className="relative -mt-8 flex flex-col items-center gap-1 active:scale-95 transition-transform duration-150"
                  data-testid="nav-ai-chat"
                >
                  <div className="relative">
                    <div className="relative w-14 h-14 bg-gradient-to-br from-violet-500 via-purple-500 to-pink-500 rounded-2xl shadow-xl shadow-purple-500/40 flex items-center justify-center ring-4 ring-white">
                      <Sparkles className="w-6 h-6 text-white" />
                    </div>
                    {/* Status dot */}
                    <span className="absolute -top-1 -right-1 w-4 h-4 bg-green-400 rounded-full border-2 border-white shadow-lg" />
                  </div>
                  <span className="text-[10px] font-bold text-purple-600 mt-1">Sahbi AI</span>
                </button>
                
                <button
                  onClick={() => onNavigateTo('afspraken')}
                  className="flex flex-col items-center gap-1 px-4 sm:px-6 py-3 rounded-2xl hover:bg-slate-100 text-slate-400 hover:text-slate-700 active:scale-95 transition-transform duration-150"
                  data-testid="nav-afspraken"
                >
                  <CalendarDays className="w-5 h-5" />
                  <span className="text-[10px] font-semibold">Afspraken</span>
                </button>
                
                <button
                  onClick={() => onNavigateTo('klusjes')}
                  className="flex flex-col items-center gap-1 px-4 sm:px-6 py-3 rounded-2xl hover:bg-slate-100 text-slate-400 hover:text-slate-700 active:scale-95 transition-transform duration-150"
                  data-testid="nav-klusjes"
                >
                  <CheckSquare className="w-5 h-5" />
                  <span className="text-[10px] font-semibold">Klusjes</span>
                </button>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default HomeScreen;
